module.exports = __webpack_public_path__ + "media/images/athletes/373-b3d1e68d4f25908fda51af1bd9c42b86.png";